import {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'

// rsuite
import Table from 'rsuite/Table'
import Tag from 'rsuite/Tag'
import Toggle from 'rsuite/Toggle'
import Tooltip from 'rsuite/Tooltip'
import Whisper from 'rsuite/Whisper'

// includes
import Edit2 from '@rsuite/icons/Edit'
import TrashIcon from '@rsuite/icons/Trash'
import UserInfoIcon from '@rsuite/icons/UserInfo'
import axios from 'axios'
import {isEmpty} from 'lodash'
import moment from 'moment'
import {useHistory} from 'react-router-dom'
import {toast} from 'react-toastify'
import {Badge} from 'rsuite'
import {SortType} from 'rsuite-table/lib/@types/common'
import Pagination from 'rsuite/Pagination'
import IconButton from 'rsuite/esm/IconButton'
import {IAuthState} from 'src/app/modules/auth'
import {ItemType, StateParamsModel} from 'src/app/modules/common/Model'
import checkBackendSetting from 'src/app/modules/common/checkBackendSetting'
import CheckPermissions from 'src/app/modules/common/checkPermission'
import DeleteModal from 'src/app/modules/common/components/deleteModal'
import DesignComponent from 'src/app/modules/common/components/designComponent'
import RSuiteTable from 'src/cms/helpers/components/rsuiteTable'
import {columnModel} from 'src/cms/helpers/components/rsuiteTable/Models/columnModel'
import {REACT_APP_API_URL} from 'src/cms/helpers/constants'
import * as auctionRedux from '../index'
import AddAuction from './AddAuction'

const AuctionComponent = () => {
  let history = useHistory()
  const dispatch = useDispatch()
  const [open, setOpen] = useState(false)
  const [actionType, setActionType] = useState('Add')
  const {
    data,
    loading,
    singleEnableSuccess,
    singleDisableSuccess,
    enableSuccess,
    disableSuccess,
    toggleLoading,
    success,
    deleteSuccess,
    sortAuctionData,
  } = useSelector((state: any) => state.auction)
  const [params, setParams] = useState<StateParamsModel>({
    page: 1,
    limit: 10,
  })
  const [checkedValues, setCheckedValues] = useState<Array<string>>([])
  const [editSelectedData, setEditCheckedData] = useState<any>()

  // alert modal
  const [alertOpen, setAlertOpen] = useState(false)
  const handleAlertOpen = () => setAlertOpen(true)
  const handleAlertClose = () => setAlertOpen(false)
  const [openSortModal, setOpenSortModal] = useState(false)

  const isAssetType = checkBackendSetting('isAssetType')
  const enableMakerChecker = checkBackendSetting('enableMakerChecker')

  const auth: IAuthState = useSelector((state: any) => state.auth)

  const isAuctionMaker = auth?.rolePermissions?.name === 'Auction Maker'

  const handleChangeLimit = (dataKey: number) => {
    setParams({
      ...params,
      limit: dataKey,
    })
  }

  const enableAuctionData = () => {
    if (!isEmpty(checkedValues)) {
      const formData = checkedValues.map((d: string) => ({
        id: d,
      }))
      dispatch(auctionRedux.actions.enableAuction(formData))
    } else {
      toast.error('No data Selected')
    }
  }

  const disableAuctionData = () => {
    if (!isEmpty(checkedValues)) {
      const formData = checkedValues.map((d: string) => ({
        id: d,
      }))
      dispatch(auctionRedux.actions.disableAuction(formData))
    } else {
      toast.error('No data Selected')
    }
  }

  const ActionCell = ({rowData, dataKey, ...props}: any) => {
    function handleAction() {
      alert(`id:${rowData[dataKey]}`)
    }
    return (
      <Cell {...props} className='link-group' data-cy='search-category-link-group'>
        <Whisper placement='top' trigger='hover' speaker={<Tooltip>Auction Enquiry</Tooltip>}>
          <Badge
            content={
              rowData?.auctionEnquiryUnSeenCount > 0 ? rowData?.auctionEnquiryUnSeenCount : false
            }
            className='auction-enquiry-count-badge'
          >
            <IconButton
              appearance='subtle'
              onClick={() => {
                history.push(`/auction/auction-manager/auction-enquiry/${rowData.id}`)
              }}
              icon={<UserInfoIcon />}
              data-cy='edit-button'
            />
          </Badge>
        </Whisper>
        <CheckPermissions type='Edit'>
          <Whisper
            placement='top'
            trigger='hover'
            data-cy='search-category-edit-button'
            speaker={<Tooltip>Edit</Tooltip>}
          >
            <IconButton
              appearance='subtle'
              onClick={() => {
                if (enableMakerChecker) {
                  if (isAuctionMaker && rowData?.status) {
                    toast.error('The Auction has already been activated')
                    return
                  }
                }
                setEditCheckedData(rowData)
                setActionType('Edit')
                setOpen(true)
              }}
              icon={<Edit2 />}
              data-cy='edit-button'
            />
          </Whisper>
        </CheckPermissions>
        <CheckPermissions type='Delete'>
          <Whisper
            placement='top'
            trigger='hover'
            data-cy='search-category-delete-button'
            speaker={<Tooltip>Delete</Tooltip>}
          >
            <IconButton
              appearance='subtle'
              onClick={() => {
                handleAlertOpen()
                let auctionId = [rowData.id]
                setCheckedValues(auctionId)
              }}
              icon={<TrashIcon />}
              data-cy='delete-button'
            />
          </Whisper>
        </CheckPermissions>
        {(enableMakerChecker ? !isAuctionMaker : true) && (
          <Whisper
            placement='top'
            trigger='hover'
            data-cy='search-category-status-button'
            speaker={<Tooltip>Status</Tooltip>}
          >
            <Toggle
              size='sm'
              disabled={toggleLoading}
              checked={rowData.status}
              onClick={() => handleToggleAction(rowData)}
              data-cy='toggle-button'
            />
          </Whisper>
        )}
      </Cell>
    )
  }

  const handleToggleAction = (data: {[key: string]: string}) => {
    data?.status
      ? dispatch(auctionRedux.actions.singleDisableAuction({id: data.id}))
      : dispatch(auctionRedux.actions.singleEnableAuction({id: data.id}))
  }

  const Cell = Table.Cell

  const handleClose = () => setOpen(false)

  const columns: columnModel[] = [
    {
      label: 'S.N.',
      dataKey: 'sn',
      width: 50,
      cell: <Cell dataKey='sn' />,
    },
    {
      label: 'Auction Code',
      dataKey: 'auctionCode',
      width: 130,
      cell: <Cell dataKey='auctionCode' />,
    },
    {
      label: 'Name',
      dataKey: 'name',
      width: 200,
      cell: <Cell dataKey='name' />,
      sortable: true,
    },
    {
      label: 'Auction Type',
      dataKey: 'auctionType',
      width: 130,
      cell: (
        <Cell>{(rowData) => (rowData.auctionType?.name ? rowData.auctionType?.name : '-')}</Cell>
      ),
      sortable: false,
    },
    {
      label: isAssetType ? 'Asset Type' : 'Property Type',
      dataKey: 'propertyType',
      width: 130,
      cell: (
        <Cell>{(rowData) => (rowData.propertyType?.name ? rowData.propertyType?.name : '-')}</Cell>
      ),
      sortable: false,
    },
    {
      label: 'Slug',
      dataKey: 'slug',
      width: 130,
      cell: <Cell>{(rowData) => rowData?.slug ?? '-'}</Cell>,
      sortable: false,
    },
    {
      label: 'Start Date',
      dataKey: 'start_date',
      width: 110,
      cell: (
        <Cell>
          {(rowData) =>
            rowData.start_date ? moment(rowData?.start_date).format('YYYY-MM-DD') : '-'
          }
        </Cell>
      ),
      sortable: false,
    },
    {
      label: 'End Date',
      dataKey: 'end_date',
      width: 110,
      cell: (
        <Cell>
          {(rowData) => (rowData.end_date ? moment(rowData?.end_date).format('YYYY-MM-DD') : '-')}
        </Cell>
      ),
      sortable: false,
    },
    {
      label: 'Status',
      dataKey: 'status',
      width: 85,
      fixed: 'right',
      cell: (
        <Cell>
          {(rowData) =>
            rowData?.status ? (
              <Tag color='green' size='sm'>
                Active
              </Tag>
            ) : (
              <Tag color='red' size='sm'>
                Inactive
              </Tag>
            )
          }
        </Cell>
      ),
      sortable: false,
    },
    {
      label: 'Action',
      width: 150,
      align: 'center',
      fixed: 'right',
      cell: <ActionCell dataKey='id' />,
    },
  ]

  useEffect(() => {
    dispatch(auctionRedux.actions.getAuction(params))
  }, [params])

  const handleChecked = (values: Array<string>) => {
    setCheckedValues(values)
  }
  const handleExport = () => {
    axios
      .get(REACT_APP_API_URL + `/auction/export`, {
        params: {search: params?.search !== '' ? params?.search : null},
      })
      .then((response) => {
        const blob = new Blob([response.data])
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'auction-list.csv')
        document.body.appendChild(link)
        link.click()
      })
  }
  useEffect(() => {
    if (deleteSuccess) {
      toast.success('Auction deleted successfully')
    }
    if (enableSuccess) {
      toast.success('Auction enabled successfully')
    }
    if (disableSuccess) {
      toast.success('Auction disabled successfully')
    }
    handleChecked([])
    dispatch(auctionRedux?.actions.getAuction(params))
  }, [deleteSuccess, success, enableSuccess, disableSuccess])

  useEffect(() => {
    if (singleEnableSuccess) {
      toast.success('Auction enabled successfully')
    }
    if (singleDisableSuccess) {
      toast.success('Auction disabled successfully')
    }
    handleChecked([])
  }, [singleDisableSuccess, singleEnableSuccess])

  const auctionData = data?.auction
    ? data?.auction?.map((item: any, i: number) => ({
        sn: (params?.page - 1) * params?.limit + (i + 1),
        id: item.id,
        slug: item?.slug,
        auctionCode: item?.auctionCode,
        is_nba: item?.is_nba ? 'true' : 'false',
        propertyType: item?.propertyType,
        property_type_id: item?.propertyType?.id,
        auctionType: item?.auctionType,
        auction_type_id: item?.auctionType?.id,
        district: item?.district,
        district_id: item?.district?.id,
        province: item?.province,
        province_id: item?.province?.id,
        address1: item?.address1,
        address2: item?.address2,
        addressCategory: item?.addressCategoryOption,
        address_category_id: item?.addressCategoryOption?.id,
        start_date: item?.start_date ? moment(item?.start_date).toDate() : null,
        start_time: item?.start_time ? moment(item?.start_time).toDate() : null,
        end_date: item?.end_date ? moment(item?.end_date).toDate() : null,
        end_time: item?.end_time ? moment(item?.end_time).toDate() : null,
        name: item?.name,
        latitude: item?.latitude,
        longitude: item?.longitude,
        images: item?.images?.auctionImage
          ?.sort((a: {order: number}, b: {order: number}) => a?.order - b?.order)
          .map((item: {[key: string]: string}) => ({
            id: item.id,
            order: item?.order,
            path: item?.path,
            image_type_id: item?.imageTypeId,
            show_in_listing: item?.show_in_listing ? 'true' : 'false',
            primary_image: item?.primary_image ? 'true' : 'false',
          })),
        properties: item?.properties?.auctionProperty
          ?.sort((a: {order: number}, b: {order: number}) => a?.order - b?.order)
          .map((item: {[key: string]: string}) => ({
            id: item.id,
            order: item?.order,
            key: item?.key,
            value: item?.value,
            show_in_listing: item?.show_in_listing ? 'true' : 'false',
          })),
        personalDetails: item?.personalDetails?.auctionPersonalDetail?.map(
          (item: {[key: string]: string}) => ({
            name: item?.name,
            number: item?.number,
          })
        ),
        plus_code: item?.plus_code,
        status: item?.status,
        order: item?.order,
        qr_path: item?.qr_path,
        description: item?.description,
        descriptionNp: item?.descriptionNp,
        attachments: item?.attachments,
        auctionEnquiryUnSeenCount: item?.auctionEnquiryUnSeenCount,
        primaryImage: item?.primaryImage,
      }))
    : []

  const handleSort = (dataKey: string, sortType?: SortType) => {
    setParams({...params, orderBy: dataKey, order: sortType})
  }

  const handleAddModal = () => {
    setEditCheckedData({})
    setOpen(true)
    setActionType('Add')
  }

  const handleDelete = () => {
    let auctionId = checkedValues?.map((value) => ({id: value}))
    dispatch(auctionRedux?.actions?.deleteAuction(auctionId))
    handleAlertClose()
  }

  const handleRefresh = () => {
    dispatch(auctionRedux.actions.getAuction(params))
  }

  const handleGetAllData = () => {
    setParams({...params, limit: data?.meta?.total})
    dispatch(auctionRedux.actions.getAuction(params))
  }

  const handleSubmitSort = (data: Array<ItemType>) => {
    let body = {
      auctionId: data?.map((item) => ({id: item?.keyId})),
    }
    dispatch(auctionRedux.actions.sortAuction(body))
  }

  useEffect(() => {
    if (!isEmpty(sortAuctionData) && success) {
      toast.success('Auction sorted successfully')
      dispatch(auctionRedux.actions.sortAuctionReset())
      setParams({...params, limit: 10})
      dispatch(auctionRedux.actions.getAuction(params))
      setOpenSortModal(false)
    }
  }, [sortAuctionData, success])

  return (
    <>
      <div className='shadow p-3 bg-white rounded' data-cy='search-category-shadow-comp'>
        <DesignComponent
          moduleName='Auction Manager'
          params={params}
          setParams={setParams}
          handleRefresh={handleRefresh}
          handleAddModal={handleAddModal}
          handleAlertOpen={handleAlertOpen}
          exportShow={true}
          importShow={false}
          handleExport={handleExport}
          enableMultiple={enableAuctionData}
          disableMultiple={disableAuctionData}
          data={auctionData}
          sortButtonName='Sort'
          handleSubmitSort={handleSubmitSort}
          handleGetAllData={handleGetAllData}
          openSortModal={openSortModal}
          setOpenSortModal={setOpenSortModal}
          loading={loading}
          toggleMultipleShow={enableMakerChecker ? (isAuctionMaker ? false : true) : true}
          sortShow={enableMakerChecker ? (isAuctionMaker ? false : true) : true}
          data-cy='search-category-design-comp'
        />

        <div className='datatable' data-cy='search-category-datatable'>
          <RSuiteTable
            onChecked={handleChecked}
            showCheckbox={true}
            columns={columns}
            data={auctionData}
            checkedValues={checkedValues}
            showLoading={loading}
            handleSort={handleSort}
            data-cy='search-category-r-suite'
          />
          <Pagination
            prev
            next
            first
            last
            ellipsis
            boundaryLinks
            className='mt-5'
            maxButtons={5}
            size='sm'
            layout={['total', '-', 'limit', '|', 'pager', 'skip']}
            total={data?.meta?.total || 0}
            limitOptions={[10, 20, 50, 100]}
            limit={params?.limit}
            activePage={params?.page}
            onChangePage={(value) => setParams({...params, page: value})}
            onChangeLimit={handleChangeLimit}
            data-cy='search-category-pagination'
          />
          {open && (
            <AddAuction
              open={open}
              params={params}
              handleClose={handleClose}
              actionType={actionType}
              editSelectedData={editSelectedData}
            />
          )}
        </div>

        {/* Delete Modal */}
        <>
          {alertOpen &&
            (!isEmpty(checkedValues) ? (
              <DeleteModal
                handleClick={() => handleDelete()}
                isOpen={alertOpen}
                handleClose={() => handleAlertClose()}
              />
            ) : (
              toast.error('No data selected') && setAlertOpen(false)
            ))}
        </>
      </div>
    </>
  )
}

export default AuctionComponent
